<template>
  <div class="agente-ia">
    <!-- Loader al abrir el módulo (~4s) -->
    <div v-if="cargando" class="agente-ia__loader">
      <button
        type="button"
        class="agente-ia__loader-back"
        aria-label="Volver"
        @click="irAPerfil"
      >
        <v-icon color="#8fa8bc">mdi-arrow-left</v-icon>
      </button>

      <div class="agente-ia__loader-content">
        <div class="agente-ia__loader-circle">IA</div>
        <div class="agente-ia__loader-title">Práctica con la IA</div>
        <div class="agente-ia__loader-dots" aria-hidden="true">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="agente-ia__loader-text">
          Cargando tus conversaciones para mejorar tu aprendizaje
        </div>
      </div>
    </div>

    <!-- Lista de conversaciones -->
    <template v-else>
      <div class="agente-ia__header">
        <v-btn icon class="agente-ia__back" @click="irAPerfil">
          <v-icon color="#006093">mdi-arrow-left</v-icon>
        </v-btn>
        <div>
          <div class="agente-ia__title">Práctica con la IA</div>
          <div class="agente-ia__subtitle">{{ subtitulo }}</div>
        </div>
      </div>

      <div class="agente-ia__lista">
        <div
          v-for="conversacion in conversaciones"
          :key="conversacion.id"
          class="agente-ia__card"
          :class="{
            'agente-ia__card--bloqueada': conversacion.estado === 'bloqueada',
          }"
          @click="abrirConversacion(conversacion)"
        >
          <div
            class="agente-ia__icono"
            :class="claseIcono(conversacion.estado)"
          >
            <v-icon v-if="conversacion.estado === 'completada'" small color="white">
              mdi-check
            </v-icon>
            <v-icon v-else-if="conversacion.estado === 'bloqueada'" small color="#8fa3b3">
              mdi-lock
            </v-icon>
            <span v-else>{{ conversacion.numero }}</span>
          </div>

          <div class="agente-ia__info">
            <div class="agente-ia__card-titulo">
              Conversación {{ conversacion.numero }} — {{ conversacion.tema }}
            </div>
            <div class="agente-ia__card-meta">
              {{ metaConversacion(conversacion) }}
            </div>
          </div>

          <div
            class="agente-ia__accion"
            :class="{ 'agente-ia__accion--muted': conversacion.estado === 'bloqueada' }"
          >
            {{ textoAccion(conversacion.estado) }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
const LOADER_MS = 4000

export default {
  name: 'AgenteIA',

  data() {
    return {
      cargando: this.$route.query.skipLoader !== '1',
      loaderTimer: null,
      conversaciones: [
        {
          id: 1,
          numero: 1,
          tema: 'Libros favoritos',
          intercambios: 6,
          estado: 'completada',
        },
        {
          id: 2,
          numero: 2,
          tema: 'Hábitos de lectura',
          intercambios: 6,
          estado: 'en_progreso',
        },
        {
          id: 3,
          numero: 3,
          tema: 'Tiempo libre',
          intercambios: 6,
          estado: 'bloqueada',
        },
      ],
    }
  },

  computed: {
    subtitulo() {
      return 'Nivel 4 · Lección 2 — Let\'s practice common english'
    },
  },

  mounted() {
    if (!this.cargando) return

    this.loaderTimer = setTimeout(() => {
      this.cargando = false
      this.loaderTimer = null
    }, LOADER_MS)
  },

  beforeDestroy() {
    if (this.loaderTimer) {
      clearTimeout(this.loaderTimer)
      this.loaderTimer = null
    }
  },

  methods: {
    irAPerfil() {
      const roll = this.$store.state.login.usuario && this.$store.state.login.usuario.roll
      const destino = roll === 'TEACHER' ? 'PerfilTeacher' : 'Perfil'
      this.$router.replace({ name: destino })
    },

    claseIcono(estado) {
      if (estado === 'completada') return 'agente-ia__icono--ok'
      if (estado === 'bloqueada') return 'agente-ia__icono--lock'
      return 'agente-ia__icono--num'
    },

    metaConversacion(conversacion) {
      if (conversacion.estado === 'completada') {
        return `${conversacion.intercambios} intercambios · completada`
      }
      if (conversacion.estado === 'en_progreso') {
        return `${conversacion.intercambios} intercambios · en progreso`
      }
      return `Se desbloquea al terminar la ${conversacion.numero - 1}`
    },

    textoAccion(estado) {
      if (estado === 'completada') return 'Repasar'
      if (estado === 'en_progreso') return 'Continuar'
      return 'Bloqueada'
    },

    abrirConversacion(conversacion) {
      if (conversacion.estado === 'bloqueada') return

      this.$router.push({
        path: `/agente-ia/chat/${conversacion.id}`,
        query: { tema: conversacion.tema },
      })
    },
  },
}
</script>

<style scoped>
.agente-ia {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: calc(56px + env(safe-area-inset-bottom, 0px));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f4f7fa;
  color: #1a2b3c;
  z-index: 2;
}

/* —— Loader apertura —— */
.agente-ia__loader {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0f1a28;
  position: relative;
  padding: 24px;
}

.agente-ia__loader-back {
  position: absolute;
  top: 12px;
  left: 12px;
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.agente-ia__loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 280px;
}

.agente-ia__loader-circle {
  width: 88px;
  height: 88px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 1px;
  margin-bottom: 20px;
}

.agente-ia__loader-title {
  font-size: 20px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 18px;
}

.agente-ia__loader-dots {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}

.agente-ia__loader-dots span {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4a6f88;
  animation: agente-ia-dot 1.2s ease-in-out infinite;
}

.agente-ia__loader-dots span:nth-child(1) {
  background: #4db8e8;
  animation-delay: 0s;
}

.agente-ia__loader-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.agente-ia__loader-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

.agente-ia__loader-text {
  font-size: 13px;
  line-height: 1.45;
  color: #8fa8bc;
}

@keyframes agente-ia-dot {
  0%, 80%, 100% {
    opacity: 0.35;
    transform: scale(0.85);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
}

/* —— Lista —— */
.agente-ia__header {
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  gap: 4px;
  padding: calc(12px + env(safe-area-inset-top, 0px)) 16px 12px;
  flex-shrink: 0;
  background: #f4f7fa;
  border-bottom: 1px solid #e4edf3;
  box-sizing: border-box;
}

.agente-ia__back {
  margin-left: -8px;
  margin-top: -4px;
}

.agente-ia__title {
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  color: #006093;
}

.agente-ia__subtitle {
  margin-top: 4px;
  font-size: 13px;
  color: #6b8296;
}

.agente-ia__lista {
  flex: 1 1 auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  width: 100%;
  max-width: 560px;
  margin: 0 auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-sizing: border-box;
}

.agente-ia__card {
  display: flex;
  align-items: center;
  gap: 14px;
  background: #fff;
  border: 1px solid #dce6ee;
  border-radius: 16px;
  padding: 16px;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 96, 147, 0.06);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.agente-ia__card:hover:not(.agente-ia__card--bloqueada) {
  border-color: #9fc4d9;
  box-shadow: 0 4px 14px rgba(0, 96, 147, 0.1);
}

.agente-ia__card--bloqueada {
  opacity: 0.6;
  cursor: default;
  background: #f8fafc;
}

.agente-ia__icono {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-weight: 700;
  font-size: 15px;
}

.agente-ia__icono--ok,
.agente-ia__icono--num {
  background: #006093;
  color: #fff;
}

.agente-ia__icono--lock {
  background: #d5e0e8;
}

.agente-ia__info {
  flex: 1;
  min-width: 0;
}

.agente-ia__card-titulo {
  font-size: 14px;
  font-weight: 600;
  color: #1a2b3c;
  line-height: 1.3;
}

.agente-ia__card--bloqueada .agente-ia__card-titulo {
  color: #7a90a2;
}

.agente-ia__card-meta {
  margin-top: 4px;
  font-size: 12px;
  color: #6b8296;
}

.agente-ia__accion {
  font-size: 13px;
  font-weight: 600;
  color: #006093;
  flex-shrink: 0;
  white-space: nowrap;
}

.agente-ia__accion--muted {
  color: #8fa3b3;
}

@media (min-width: 960px) {
  .agente-ia__header,
  .agente-ia__lista {
    max-width: 520px;
  }

  .agente-ia__title {
    font-size: 24px;
  }

  .agente-ia__card {
    padding: 18px 20px;
  }
}
</style>
